// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3cjtw","itemA":"Write_itemA__9I9Zi","itemB":"Write_itemB__1M3bH","itemC":"Write_itemC__238Qn","itemD":"Write_itemD__2YARD"};